import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import api from '../lib/api';
import { workingHoursTypeEnum } from '../enums';
import { sportFlagsToKeysArray } from '../lib/sportUtils';
import Timetable from './Timetable';

/**
 * Тот же Timetable, что на карточке площадки — для входа из «Секции → Расписание».
 */
export class PlaygroundTimetableEmbed extends Component {
  static propTypes = {
    playgroundId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    sportComplexId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    initialSectionFilterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sports: PropTypes.object,
    classes: PropTypes.object,
  };

  static defaultProps = {
    sportComplexId: null,
    initialSectionFilterId: '',
    sports: {},
    classes: {},
  };

  state = {
    loading: true,
    error: '',
    playgroundId: null,
    sport: ['football'],
    workingHoursTypes: ['full'],
    workingHoursSports: {},
    currentWorkingHoursTypes: workingHoursTypeEnum.full,
  };

  componentDidMount() {
    this.loadPlayground(this.props.playgroundId);
  }

  componentDidUpdate(prevProps) {
    if (String(prevProps.playgroundId) !== String(this.props.playgroundId)) {
      this.loadPlayground(this.props.playgroundId);
    }
  }

  loadPlayground = async (rawId) => {
    const id = Number(rawId);
    if (!id || Number.isNaN(id)) {
      this.setState({ loading: false, error: 'Не выбрана площадка', playgroundId: null });
      return;
    }
    this.setState({ loading: true, error: '' });
    try {
      const full = await api.getPlayground(id);
      const workingHoursTypes = (full && full.workingHoursTypes && full.workingHoursTypes.length)
        ? full.workingHoursTypes.map((t) => String(t).toLowerCase())
        : ['full'];
      const sports = (full && full.sports) || {};
      const workingHoursSports = {};
      Object.keys(sports).forEach((key) => {
        const keyLower = String(key).toLowerCase();
        let typeKey = keyLower;
        if (key === 0 || key === '0' || keyLower === 'full') typeKey = 'full';
        else if (key === 1 || key === '1' || keyLower === 'half') typeKey = 'half';
        else if (key === 2 || key === '2' || keyLower === 'third') typeKey = 'third';
        const flags = sports[key];
        if (Array.isArray(flags) && flags.length) {
          workingHoursSports[typeKey] = sportFlagsToKeysArray(flags);
        }
      });
      const sport = full && full.sport
        ? sportFlagsToKeysArray(Array.isArray(full.sport) ? full.sport : [full.sport])
        : ['football'];
      const current = workingHoursTypes.includes('full')
        ? workingHoursTypeEnum.full
        : (workingHoursTypes[0] || workingHoursTypeEnum.full);
      this.setState({
        loading: false,
        error: '',
        playgroundId: id,
        sport: sport.length ? sport : ['football'],
        workingHoursTypes,
        workingHoursSports,
        currentWorkingHoursTypes: current,
      });
    } catch (e) {
      this.setState({
        loading: false,
        error: (e && e.message) || 'Не удалось загрузить площадку',
        playgroundId: null,
      });
    }
  };

  changeCurrentWorkingHoursType = (type) => {
    this.setState({ currentWorkingHoursTypes: type });
  };

  addWorkingHoursType = () => {
    /* read-only embed: типы часов меняются в карточке площадки */
  };

  handleWorkingHoursSportsChange = () => {
    /* read-only embed */
  };

  noopSubmit = () => {};

  render() {
    const { classes, sports, sportComplexId, initialSectionFilterId } = this.props;
    const {
      loading,
      error,
      playgroundId,
      sport,
      workingHoursTypes,
      workingHoursSports,
      currentWorkingHoursTypes,
    } = this.state;

    if (loading) {
      return (
        <div className={classes.loader}>
          <CircularProgress size={28} />
        </div>
      );
    }
    if (error || !playgroundId) {
      return (
        <Typography color="error" className={classes.error}>
          {error || 'Площадка недоступна'}
        </Typography>
      );
    }

    const complexId = sportComplexId != null && sportComplexId !== ''
      ? Number(sportComplexId)
      : null;

    return (
      <Paper variant="outlined" className={classes.wrap} elevation={0}>
        <Timetable
          key={`embed-tt-${playgroundId}-${initialSectionFilterId || ''}`}
          sport={sport}
          sports={sports || {}}
          playgroundId={playgroundId}
          submit={this.noopSubmit}
          currentWorkingHoursTypes={currentWorkingHoursTypes}
          workingHoursTypes={workingHoursTypes}
          workingHoursSports={workingHoursSports}
          changeCurrentWorkingHoursType={this.changeCurrentWorkingHoursType}
          addWorkingHoursType={this.addWorkingHoursType}
          onWorkingHoursSportsChange={this.handleWorkingHoursSportsChange}
          initialSectionFilterId={initialSectionFilterId || ''}
          sportComplexId={Number.isFinite(complexId) ? complexId : null}
        />
      </Paper>
    );
  }
}

const styles = (theme) => ({
  wrap: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    overflowX: 'auto',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  error: {
    marginTop: theme.spacing(1),
  },
});

export default connect((state) => ({
  sports: state.sports,
}))(withStyles(styles)(PlaygroundTimetableEmbed));
